import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '50rem',
    justifyContent: 'center',
  },
  title: {
    fontSize: 32,
    textTransform: 'uppercase',
  },
  subTitle: {
    fontSize: 20,
    marginTop: '1rem',
    color: theme.palette.text.primary,
  },
  buttonRow: {
    marginBottom: '2rem',
    marginTop: '1rem',
  },
  message: {
    fontSize: 16,
    fontStyle: 'italic',
    color: theme.palette.text.alternate,
  },
}));

export default useStyles;
